import React, { useEffect, useMemo, useState } from "react"
import { getAuthUser } from "helpers/token_helper"

//redux
import { useSelector, useDispatch } from "react-redux"
import { isEmpty } from "lodash"

import { getProfile as onGetProfile } from "store/actions"

const useUserDetail = () => {
  const dispatch = useDispatch()
  const [profile, setProfile] = useState({})

  useEffect(() => {
    if (getAuthUser()) {
      setProfile(getAuthUser())
    }
  }, [])

  useEffect(() => {
    if (!isEmpty(profile)) {
      dispatch(onGetProfile(profile.RowID))
    }
  }, [profile])

  //////////////////USER STATE/////////////////////
  const { userprofile } = useSelector(state => state.user)
  //////////////////////////////////////

  return { userprofile }
}

export default useUserDetail
